import { create } from "zustand";
import { com } from "../proto/game.pb";

export type UserProfile = com.achlid.crash.game.stateless.IUserProfileResponse;

export type UserStoreState = {
  profile: UserProfile | null;
  setProfile: (profile: UserProfile | null) => void;
  updateProfile: (patch: Partial<UserProfile>) => void;
  clearProfile: () => void;
};

export const useUserStore = create<UserStoreState>((set) => ({
  profile: null,
  setProfile: (profile) => set(() => ({ profile })),
  updateProfile: (patch) =>
    set((state) => ({
      profile: state.profile ? { ...state.profile, ...patch } : (patch ?? null),
    })),
  clearProfile: () => set(() => ({ profile: null })),
}));
